import React from 'react';
import { Descriptions, Card, Button } from 'antd';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { useHistory, useParams } from 'react-router-dom';
import { Navigation } from '@constants/Navigation';
import api from '@services/api';
import { DeviceTypeResponse } from '@openapi';

const InfoDeviceTypeModal = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const [deviceType, setDeviceType] = React.useState<DeviceTypeResponse>();

  const onClose = () => {
    history.push(Navigation.DeviceType);
  };

  React.useEffect(() => {
    api.administration.getDeviceType(id).then((data) => {
      setDeviceType(data);
    });
  }, []);

  return (
    <Card
      title="Device Type Info"
      extra={
        <Button icon={<ArrowLeftOutlined />} type="default" onClick={onClose}>
          Back to Device Type Page
        </Button>
      }
    >
      <Descriptions labelStyle={{ fontWeight: '500', fontSize: '16px' }} layout="horizontal" column={1} bordered>
        <Descriptions.Item label="Id">{deviceType?.id}</Descriptions.Item>
        <Descriptions.Item label="Hardware Id">{deviceType?.hardwareId}</Descriptions.Item>
        <Descriptions.Item label="Usage Id">{deviceType?.usageId}</Descriptions.Item>
        <Descriptions.Item label="Name">{deviceType?.deviceName}</Descriptions.Item>
        <Descriptions.Item label="Scope">{deviceType?.scope}</Descriptions.Item>
        <Descriptions.Item label="Rescue Name">{deviceType?.rescueName}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default React.memo(InfoDeviceTypeModal);
